import clsx from 'clsx';

export interface DpChoice {
    value: 'approve' | 'reject';
    label: string;
    hint?: string;
}

interface DpChoiceGroupProps {
    name: string;
    legend: string;
    hint?: string;
    choices: DpChoice[];
    value?: 'approve' | 'reject';
    onChange: (value: 'approve' | 'reject') => void;
    error?: string;
    disabled?: boolean;
}

export function DpChoiceGroup({
    name,
    legend,
    hint,
    choices,
    value,
    onChange,
    error,
    disabled = false,
}: DpChoiceGroupProps) {
    return (
        <fieldset disabled={disabled}>
            <legend className="text-base font-semibold text-raro-gray-900 font-montserrat">
                {legend}
            </legend>
            {hint && (
                <p className="mt-1 text-sm text-raro-gray-500 font-montserrat">{hint}</p>
            )}

            <div className="mt-2 grid gap-2 sm:grid-cols-2">
                {choices.map((choice) => {
                    const selected = value === choice.value;
                    const isReject = choice.value === 'reject';

                    return (
                        <label
                            key={choice.value}
                            className={clsx(
                                'flex cursor-pointer gap-2.5 rounded-xl border p-4 transition-colors',
                                selected
                                    ? isReject
                                        ? 'border-red-300 bg-red-50'
                                        : 'border-primary-300 bg-primary-50'
                                    : 'border-raro-gray-200 hover:border-raro-gray-300',
                                disabled && 'cursor-not-allowed opacity-60'
                            )}
                        >
                            <input
                                type="radio"
                                name={name}
                                value={choice.value}
                                checked={selected}
                                onChange={() => onChange(choice.value)}
                                className={clsx(
                                    'mt-0.5 h-4 w-4 shrink-0',
                                    isReject
                                        ? 'text-red-600 focus:ring-red-500'
                                        : 'text-primary-600 focus:ring-primary-500'
                                )}
                            />
                            <span className="min-w-0">
                                <span className="block text-base font-medium text-raro-gray-900 font-montserrat">
                                    {choice.label}
                                </span>
                                {choice.hint && (
                                    <span className="mt-0.5 block text-sm text-raro-gray-500 font-montserrat">
                                        {choice.hint}
                                    </span>
                                )}
                            </span>
                        </label>
                    );
                })}
            </div>

            {error && <p className="mt-1.5 text-sm text-red-600 font-montserrat">{error}</p>}
        </fieldset>
    );
}

export default DpChoiceGroup;
